module.exports = __webpack_public_path__ + "static/13-015bd70d23e9c5e959f1daa5c2ca38b5.jpg";